import { useState } from 'react'
import { useAccount } from 'wagmi'

import { Links, TokenSubLinks, getTokenSubLink } from 'constants/link'

import { useOpenModal } from 'modal'
import { newTxHistoryModal } from 'modals'

import { CustomLink, Icon, LogoLink } from 'components/ui'

import { Settings } from './Settings'
import { ConnectButton } from '../ConnectButton'

import {
  Nav,
  List,
  Wrap,
  Burger,
  Overlay,
  ListItem,
  Container,
  ButtonWrap,
  ContentWrap,
  HistoryText,
  HistoryIcon,
  HistoryButton,
} from './Style'

const Header = () => {
  const openModal = useOpenModal()
  const { isConnected } = useAccount()

  const [isOpenNav, setOpenNav] = useState(false)

  const handleClick = () => {
    setOpenNav(!isOpenNav)
    document.body.style.overflowY = isOpenNav ? 'unset' : 'hidden'
    document.body.style.overflowX = 'hidden'
  }

  const handleClickMenu = () => {
    setOpenNav(!isOpenNav)
    document.body.style.overflow = 'unset'
  }

  const openModalTxHistory = () => {
    openModal(newTxHistoryModal())
  }

  return (
    <Wrap>
      <Container>
        <LogoLink />

        <Nav role='navigation' aria-label='Navigation' isOpen={isOpenNav}>
          <List>
            <ListItem onClick={handleClickMenu}>
              <CustomLink title='_home' url={Links.TOKEN} end={false} />
            </ListItem>
            <ListItem onClick={handleClickMenu}>
              <CustomLink title='_tutorial' url={getTokenSubLink(TokenSubLinks.TUTORIAL)} />
            </ListItem>
            <ListItem onClick={handleClickMenu}>
              <CustomLink title='_faq' url={getTokenSubLink(TokenSubLinks.FAQ)} />
            </ListItem>
          </List>

          <ButtonWrap>
            <ContentWrap type='desktop'>
              {isConnected && (
                <HistoryButton onClick={openModalTxHistory}>
                  <HistoryText>_tx-history</HistoryText>
                </HistoryButton>
              )}
              <ConnectButton accountStatus='address' chainStatus='icon' />
              <Settings />
            </ContentWrap>
          </ButtonWrap>
        </Nav>

        <ContentWrap type='mobile' isConnected={isConnected}>
          {isConnected && (
            <HistoryButton type='symbol' size='symbol' onClick={openModalTxHistory}>
              <HistoryIcon>
                <Icon name='history' />
              </HistoryIcon>
            </HistoryButton>
          )}
          <ConnectButton accountStatus='address' chainStatus='icon' />
          <Settings />
        </ContentWrap>

        <Burger isOpen={isOpenNav} onClick={handleClick} />
        <Overlay isOpen={isOpenNav} onClick={handleClickMenu} role='presentation' />
      </Container>
    </Wrap>
  )
}

export { Header }
